import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";

type LoadingComponentPropsType = {
  numberOfRows: number;
  width?: number;
};
const Loading = (props: LoadingComponentPropsType) => {
  const { numberOfRows, width } = props;
  const rowsArr = Array.from(Array(numberOfRows).keys());

  return (
    <Stack
      flexDirection="column"
      gap={0.5}
      alignContent="center"
      margin="0 5px"
    >
      {rowsArr.map((el) => {
        return (
          <Skeleton
            height={50}
            variant="text"
            width={width || "100%"}
            key={`loading-row-${el}`}
            data-testid="loading-row"
            sx={{ borderRadius: "6px" }}
          />
        );
      })}
    </Stack>
  );
};

export default Loading;
